@if (displayStepper) {
  <div class="form-stepper-containers m-12 mobile:m-4 mobile:overflow-hidden mobile:overflow-x-scroll">
    <hire-form-form-stepper></hire-form-form-stepper>
  </div>
}

<div class="flex flex-row items-center mb-12 mobile:mb-6">
  <div class="flex-grow flex items-center">
    <div class="text-4xl mobile:text-2xl font-normal mb-1 mt-0 mobile:mt-4" >{{ showConfirmationPage ? 'Order Confirmation' : currentStep()?.displayTitle }}</div>
  </div>
  <div class="flex-grow-0 flex h-auto mobile:hidden">
    <!-- <hire-form-navigation-button (clicked)="goToNextStep()" [display]="currentStep() ? true : false"  [stepTitle]="nextStep()?.displayTitle || 'Process Order'" [stepIsValid]="currentStepValid"></hire-form-navigation-button> -->
    <hire-form-navigation-button [display]="currentStep() ? true :false" [stepIsValid]="currentStepValid"></hire-form-navigation-button>
  </div>
</div>


<div class="flex mobile:flex-col pb-16 mobile:pb-6">

  @if (showOrderSummary()) {
    <div class="mb-4 md:hidden">
      <div [ngClass]="{'showButton': false}" class="nav-button-cont text-right w-full">
        <hire-form-navigation-button></hire-form-navigation-button>
      </div>
      <hire-form-order-summary></hire-form-order-summary>
    </div>
  }
  <div [ngClass]="{ 'w-full': !showOrderSummary(), 'pr-8': showOrderSummary(), 'w-2/3': showOrderSummary(), 'mobile:w-full': showOrderSummary(), 'mobile:pr-0': showOrderSummary() }">
    <router-outlet></router-outlet>
  </div>
  @if (showOrderSummary()) {
    <div class="mobile:hidden w-1/3 ">
      <hire-form-order-summary></hire-form-order-summary>
    </div>
  }
</div>

@if (displayStepper) {
  <div class="md:hidden">
    <div [ngClass]="{'showButton': showNavigationButton}" class="nav-button-cont text-right w-full">
      <hire-form-navigation-button></hire-form-navigation-button>
    </div>
  </div>
}

